import BasicModal from "@/modules/common/components/modals/basic-modal";
import { muiTheme } from "@/styles/theme";
import warningIcon from "@/assets/icons/warning_amber.svg";
import { Box, Typography, Button, CircularProgress } from "@mui/material";

const ConfirmationModal = ({
  setOpen,
  open,
  title,
  body,
  onConfirmHandler,
  isLoading,
  disableConfirmButton,
  onCancelHandler = () => setOpen(false),
}: {
  setOpen: (value: boolean) => void;
  open: boolean;
  title: string;
  onConfirmHandler: any;
  body: string;
  isLoading?: boolean;
  disableConfirmButton?: boolean;
  onCancelHandler?: () => void;
}) => {
  return (
    <BasicModal
      open={open}
      setOpen={setOpen}
      width={400}
      // height={320}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          gap: 3,
          padding: 4,
        }}
      >
        <Box
          sx={{
            width: "60px",
            height: "60px",
            padding: "14px",
            backgroundColor: "#FDDDB3",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "8px",
            marginBottom: 1,
          }}
        >
          <img src={warningIcon} width={40} height={40} alt="Not Found" />
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1,
            alignItems: "center",
            textAlign: "center",
          }}
        >
          <Typography variant="h5">{title}</Typography>
          <Typography variant="body1">{body}</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            gap: 2,
            justifyContent: "space-between",
            alignItems: "center",
            width: "90%",
            marginTop: 2,
          }}
        >
          <Button
            sx={{
              textTransform: "none",
              padding: "10px 18px",
              color: muiTheme.colorSchemes.light.palette.main.black,
              borderRadius: "8px",
              border: "1px solid  #D0D5DD",
              ...muiTheme.typography.body_sm_med,
            }}
            onClick={onCancelHandler}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            sx={{
              textTransform: "none",
              padding: "10px 18px",
              borderRadius: "8px",
              minWidth: "90px",
            }}
            disabled={isLoading || disableConfirmButton}
            onClick={onConfirmHandler}
          >
            {isLoading ? (
              <CircularProgress
                sx={{
                  maxWidth: "20px",
                  maxHeight: "20px",
                  color: muiTheme.colorSchemes.light.palette.main.white,
                }}
              />
            ) : (
              "Confirm"
            )}
          </Button>
        </Box>
      </Box>
    </BasicModal>
  );
};

export default ConfirmationModal;
